var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "188px",
    viewBox: "0 0 198 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star_100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parts",
    transform: "translate(-53.000000, -47.000000)",
    fill: "#FFD21C",
    stroke: "#FFD21C",
    strokeWidth: 3.77358491
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "star_100",
    points: "152 192.356487 94.3970453 230.283665 112.667644 163.779857 58.7964614 120.716335 127.691267 117.541899 152 53 176.308733 117.541899 245.203539 120.716335 191.332356 163.779857 209.602955 230.283665"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar100);
export default __webpack_public_path__ + "static/media/star_100.f675d69afc3d300aad7117834b071cee.svg";
export { ForwardRef as ReactComponent };